<script>
import con from '@services/connection'
import { user, simulador } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      headers: [
        {
          text: 'Nome',
          value: 'nome_simulacao',
        },
        // {
        //   text: 'Cliente',
        //   value: 'nome_cliente',
        // },
        {
          text: 'Data',
          value: 'data_simulacao',
        },
        {
          text: 'P/L',
          value: 'pl_simulado',
        },
        {
          text: '',
          value: 'actions',
        },
      ],
      simulacoes: [],
      searchSimulacao: '',
      somente_atual: true,
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    clienteAtual() {
      return store.getters['user/currentClient'] || {}
    },
  },
  created() {
    GlobalBus.$on(MODAL.SIMULATOR_SEARCH_HISTORY, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.SIMULATOR_SEARCH_HISTORY, this.open)
  },
  methods: {
    open() {
      this._loadSimulacoes()
      this.busModal.$emit('dialog', true)
    },
    selectSimulacao(sim) {
      console.log(sim)
      this.bus.$emit('search_simulacao', sim)
      this.busModal.$emit('dialog', false)
    },
    async _loadSimulacoes() {
      if (this.loading) {
        return
      }
      this.loading = true
      const data = {
        id_cliente_app: this.clienteAtual.id,
      }
      const r = await con.post(simulador.listar, data)
      if (r.status === 200) {
        this.simulacoes = r.value
      } else {
        this.simulacoes = []
      }
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px">
    <Title title="Pesquisar simulação" />

    <div>
      <form
        class="d-flex align-items-center justify-content-center"
        @submit.prevent
      >
        <div class="input-group align-items-center my-5 mr-5">
          <v-text-field
            v-model="searchSimulacao"
            class="input short-search"
            append-icon=" "
            background-color="#E4E0E6"
            label=""
            full-width
            placeholder="Pesquisar"
          >
          </v-text-field>
          <button
            class="btn btn-icon btn-icon-secondary align-self-center"
            :style="{
              'background-color': '#E4E0E6',
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.276"
              height="19.966"
              viewBox="0 0 19.276 19.966"
            >
              <path
                class="fill"
                d="M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z"
                transform="translate(-.984)"
              />
            </svg>
          </button>
        </div>
        <!-- <v-checkbox
          hidden
          style="width: 280px;"
          v-model="somente_atual"
          dense
          hide-details
          class="mt-6"
          label="Somente cliente atual"
        ></v-checkbox> -->
      </form>
      <v-data-table
        :headers="headers"
        :items="simulacoes"
        height="300"
        :search="searchSimulacao"
        :loading="loading"
        fixed-header
        class="tabela-simulacoes-pesquisa"
        @click:row="selectSimulacao"
      >
        <template v-slot:item.nome_simulacao="{ item }">
          <strong> {{ item.nome_simulacao }} </strong>
        </template>
        <template v-slot:item.actions>
          <v-btn text icon small>
            <icon-svg name="mdi-chevron-right" color="#8E8E8E" size="16" />
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </BaseModal>
</template>

<style lang="sass" scope>
.tabela-simulacoes-pesquisa
  cursor: pointer
</style>
